import logo from "../assets/images/clickpass/main-logo.png"

// Colour values are duplicated from src/styles/_tokens.scss on purpose: the
// checkout kit takes plain strings (it renders into its own shadowed styles and
// can't read our CSS custom properties), so the tokens file stays the source of
// truth and these must be updated alongside it.
const TOKENS = {
  bg: "#08080c",
  panel: "#101018",
  panelRaised: "#16161f",
  ink: "#f4f4fa",
  inkMuted: "#9a9ab0",
  magenta: "#91079d",
  violet: "#b81fc7",
  line: "rgba(244, 244, 250, 0.12)",
  danger: "#dc1f3c",
  success: "#19af52"
}

export const CHECKOUT = {
  theme: {
    colorScheme: "dark",
    accent: TOKENS.magenta,
    accentHover: TOKENS.violet,
    accentContrast: "#ffffff",
    surface: TOKENS.panel,
    surfaceMuted: TOKENS.panelRaised,
    text: TOKENS.ink,
    muted: TOKENS.inkMuted,
    border: TOKENS.line,
    error: TOKENS.danger,
    success: TOKENS.success,
    radiusCard: "16px",
    radiusControl: "40px",
    shadow: "0 18px 40px rgba(0, 0, 0, 0.55)",
    font: '"Familjen Grotesk", ui-sans-serif, system-ui, sans-serif'
  },
  requireEmailConfirmation: true,
  collectTicketHolders: true,
  collectHolderContact: true,
  skipBillingWhenProfileComplete: false,
  logo
}

// The opt-in label and privacy policy are the only checkout strings the host
// controls, so they are resolved per-language at render time rather than
// baked in here. See src/components/checkout-kit/index.js.
export const checkoutCopy = t => ({
  brandOptInLabel: t("checkout:brandOptIn"),
  privacyPolicy: {
    brandName: t("common:brand"),
    linkLabel: t("checkout:privacyLinkLabel"),
    url: t("checkout:privacyUrl")
  }
})
